const randomNum = (interval, _digits = 0) => {
  const digits = 10 ** (_digits || 0);
  if (typeof interval === "number" || !isNaN(Number(interval))) {
    return (Math.round(Math.random() * interval * digits) / digits).toFixed(_digits);
  }
  const max = interval[1];
  const min = interval[0];
  let res = Math.round(((Math.random() * (max - min) - (- min)) * digits)) / digits;
  return res.toFixed(_digits);
}

export const random = (interval, options = {}) => {
  let res = [];
  const { digits, num } = options;
  if (!num) {
    return randomNum(interval, digits);
  }
  for (let i = 0; i < num; i++) {
    res.push(randomNum(interval, digits));
  }
  return res;
}